module.exports = __webpack_public_path__ + "img/025.a4df0c03.png";